import { HelpCircle, PlayCircle } from "lucide-react";
import { useLocation } from "react-router-dom";

import { pagesForPath, useGuide } from "@/components/guide/GuideContext";
import { runTour } from "@/components/guide/tour";

// Bouton « ? Guide » : ouvre la fiche de l'écran courant (ou la liste des fiches)
export const GuideButton = () => {
  const guide = useGuide();
  const { pathname } = useLocation();
  const here = pagesForPath(guide?.pages, pathname);
  return (
    <button type="button" className="guide-fab" onClick={() => guide.openGuide(here[0]?.slug || null)} data-testid="guide-open-button">
      <HelpCircle size={16} />Guide{here.length > 0 && <span className="guide-fab-count" data-testid="guide-open-count">{here.length}</span>}
    </button>
  );
};

export const GuideTourButton = ({ slug, className = "secondary-button" }) => {
  const guide = useGuide();
  const page = guide?.pages?.find((p) => p.slug === slug);
  if (!page?.tour?.length) return null;
  return <button type="button" className={className} onClick={() => runTour(page.tour)} data-testid={`guide-tour-${slug}`}><PlayCircle size={15} />Lancer la visite</button>;
};
